import { t } from "../../../data/strings";
import { dropfrontCatalog } from "../../../data/dropfront-catalog";
import type { DropfrontCardId } from "../../../data/dropfront-catalog";

export function topHtml(): string {
  return `
    <div class="df-top-row">
      <div class="df-chip" data-supply></div>
      <div class="df-hq-wrap">
        <div class="df-hq-bar"><div class="df-hq-fill" data-hq-fill></div></div>
        <div class="df-chip df-chip-hq" data-hq></div>
      </div>
      <div class="df-top-actions">
        <button type="button" class="df-icon-btn" data-pause>${t("df.pause")}</button>
        <button type="button" class="df-icon-btn" data-restart>${t("df.restart")}</button>
        <button type="button" class="df-icon-btn" data-quit>${t("df.quit")}</button>
      </div>
    </div>
    <div class="df-msg" data-msg>${t("df.msg.hint")}</div>
  `;
}

export function dockHtml(): string {
  const cards = dropfrontCatalog.cards
    .map((c) => {
      const name = t(c.nameKey);
      return `
        <button type="button" class="df-card" data-card="${c.id}">
          <img class="df-card-thumb" alt="" width="32" height="32" />
          <span class="df-card-name">${name}</span>
          <span class="df-card-cost">${c.cost}</span>
        </button>`;
    })
    .join("");
  return `<div class="df-cards">${cards}</div>`;
}

export function resultHtml(
  won: boolean,
  supply: number,
  drops: Partial<Record<DropfrontCardId, number>>,
): string {
  const lines = dropfrontCatalog.cards
    .map((c) =>
      t("df.fmt.resultLine", {
        name: t(c.nameKey),
        n: drops[c.id] ?? 0,
      }),
    )
    .join("\n");
  const body = t("df.fmt.resultBody", {
    supplyLabel: t("df.result.supply"),
    supply,
    lines,
  });
  return `
    <div class="df-result-card">
      <h2>${won ? t("df.result.won") : t("df.result.lost")}</h2>
      <p class="df-result-sub">${won ? "" : t("df.result.lostHint")}</p>
      <pre>${body}</pre>
      <button type="button" class="menu-btn menu-btn-primary" data-restart>${t("df.restart")}</button>
      <button type="button" class="menu-btn" data-quit>${t("df.quit")}</button>
    </div>
  `;
}
